import { TextRegular } from 'UiKit/typography';

import ColumnLinks from 'View/report-host-tasks/component/column-links';

import styles from './styles.module.css';

export const getTableList = ({ t }) => {
  return [
    {
      name: t("tableColumn.hostName"),
      width: 150,
      key: 'hostName',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t("tableColumn.brand"),
      width: 150,
      key: 'brand',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t("tableColumn.date"),
      width: 200,
      key: 'date',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t("tableColumn.link"),
      width: 321,
      key: 'videoUrls',
      component: ({ value }) => <ColumnLinks value={value} />,
    },
    {
      name: t("tableColumn.notes"),
      width: 321,
      key: 'note',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
  ];
};
